module.exports = __webpack_public_path__ + "static/project-10a-e36d37eebe3e4ed04a27fdbb83df7145.png";